import { useAppStore } from "@/stores/app.store"

export const getAuthTokens = () => {
  const { accessToken, refreshToken, expiresIn } = useAppStore.getState()
  return { accessToken, refreshToken, expiresIn }
}
